<template>
    <div class="w-100">
        <div class="d-flex w-100">
            <div style="width: calc(200% / 3)" class="mr-4">
                <div class="d-flex">
                    <v-text-field @input="setSearch" :value="search" append-icon="mdi-magnify" label="Rechercher par nom"
                        clearable class="mb-4" outlined hide-details :disabled="!canSearch">
                    </v-text-field>
                    <v-text-field @input="setEmailSearch" :value="emailSearch" append-icon="mdi-magnify"
                                  label="Rechercher par email" clearable class="mb-4 ml-4" outlined hide-details
                                  :disabled="!canSearch">
                    </v-text-field>
                </div>

                <div class="d-flex">
                    <v-select label="Catégorie" outlined chips small-chips deletable-chips :items="categories"
                        @input="setSelectedCategories" :value="selectedCategories" item-value="id" item-text="label"
                        class="w-50" multiple>
                    </v-select>

                    <v-select :label="cityWording" outlined chips small-chips deletable-chips :items="communes"
                        @input="setSelectedCommunes" :value="selectedCommunes" item-value="id" item-text="label"
                        class="w-50 ml-4" multiple>
                    </v-select>
                </div>

                <v-select label="Secteur touristique" outlined chips small-chips deletable-chips :items="tourismSectors"
                          @input="setSelectedTourismSectors" :value="selectedTourismSectors" item-value="id" item-text="label"
                          class="w-50 mt-4 pr-2" multiple v-if="this.account.tis_type.code === 'DAHUB_QUEBEC'">
                </v-select>
            </div>

            <div style="width: calc(100% / 3)">
                <v-select label="Statut" outlined chips small-chips deletable-chips :items="webFormStates"
                    @input="setSelectedWebFormStates" :value="selectedWebFormStates" item-value="code" item-text="label"
                    class="mb-4" multiple>
                </v-select>

                <v-select label="Tag" outlined chips @input="setSelectedTags" :items="tags" :value="selectedTags"
                    no-data-text="Aucun tag n'a encore été créé" small-chips deletable-chips item-value="id"
                    item-text="name" multiple>
                </v-select>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import _ from "lodash"

export default {
    name: "Filters",
    data() {
        return {
            loadingCommunes: false,
            searchCommunes: null,
            cityWording: 'Commune',
        }
    },
    methods: {
        ...mapMutations('providerFilter', [
            'setSearch', 'setSelectedCategories', 'setSelectedCommunes', 'removeUnavailableStates',
            'setSelectedWebFormStates', 'setSelectedTags', 'setSelectedTourismSectors', 'setEmailSearch',
        ]),
        ...mapMutations('resource', ['setWebFormStates']),
    },
    computed: {
        ...mapState('providerFilter',
            ['search', 'selectedCategories', 'selectedWebFormStates', 'selectedTags', 'selectedCommunes', "canSearch",
                "selectedTourismSectors", 'emailSearch']
        ),
        ...mapState('resource', ['webFormStates']),
        ...mapState('account', ['tags', 'categories', 'communes', 'account', "tourismSectors"]),
    },
    created() {
        this.$store.dispatch('account/fetchCategories')
        this.$store.dispatch('account/fetchCommunes')

        if (this.$route.params.hash !== undefined) {
            this.$store.dispatch('resource/fetchWebFormStates', this.account)
        } else {
            let states = [
                { code: 'WITHOUT_EMAIL', label: 'Sans destinataire' },
                { code: 'WITHOUT_TAG', label: 'Sans tag' },
                { code: 'WITHOUT_WEB_FORM', label: 'Non envoyé' }
            ]
            this.setWebFormStates(states)
            this.removeUnavailableStates()
        }

        if(this.account.configurations.quebec) {
            this.cityWording = 'Municipalité'
        }

        this.$store.dispatch('account/fetchTags')
    }
}
</script>